// src/utils/ProtectedRoute.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { hasAccess } from "./permission";

export default function ProtectedRoute({
  children,
  minLevel,
  exactLevels,
  requiredDepts,
  orMinLevel,
  orDev,
  insightSupport
}) {
  const { currentUser } = useContext(AuthContext);

  // ถ้ายังไม่รู้สถานะ (undefined) ให้รอโหลด
  if (currentUser === undefined) {
    return <div>Loading...</div>;
  }

  // ถ้าโหลดเสร็จแล้วแต่ไม่มี user => ไป login
  if (currentUser === null) {
    return <Navigate to="/login" replace />;
  }

  // ถ้ามี user แต่สิทธิ์ไม่พอ => ไป error
  if (!hasAccess(currentUser, { minLevel, exactLevels, requiredDepts, orMinLevel, orDev, insightSupport })) {
    return <Navigate to="/error" replace />;
  }

  // ผ่านทุกเงื่อนไขแล้ว ให้แสดง children
  return children;
}
